export default {"src":"/_next/static/media/twoPeopleTalkLegal_24.b23905e2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};